import {
  mdiCheckBoxOutline,
  mdiCheckboxBlankOutline,
  mdiMagnify
} from "@mdi/js";
import "./ListFilter.sass";

export default {
  name: "eo-filter",
  props: {
    settings: Object,
    countByFeature: Object,
    countByCategory: Object,
    totalCount: Number,
    locations: Array,
    ApiKey: Object
  },
  data: () => ({
    s: "", // helper to check whether search field is filled or not
    mdiCheckBoxOutline: mdiCheckBoxOutline,
    mdiCheckboxBlankOutline: mdiCheckboxBlankOutline,
    mdiMagnify: mdiMagnify
  }),
  computed: {
    selectedCategories: {
      get() {
        return this.$store.state.selectedCategories;
      },
      set(value) {
        if (!Array.isArray(value)) value = [value];
        this.$store.commit("selectCategories", value);
      }
    },
    selectedFeatures() {
      return this.$store.state.selectedFeatures;
    },
    selectedCity: {
      get() {
        return this.$store.state.selectedCity;
      },
      set(value) {
        this.$store.commit("setSelectedCity", value);
      }
    },
    selectedNormalizedCity: {
      get() {
        return this.$store.state.selectedNormalizedCity;
      },
      set(value) {
        this.$store.commit("setSelectedNormalizedCity", value);
      }
    },
    cities() {
      const cities = this.locations.filter(location => !!location.address.city);
      if (this.settings.containByCity.length) {
        return cities.filter(location =>
          this.settings.containByCity.includes(location.address.city)
        );
      }
      return cities;
    },
    normalizedCities() {
      const normalizedCities = this.locations.filter(
        location => !!location.address.normalized_city
      );
      if (this.settings.containByNormalizedCity.length) {
        return normalizedCities.filter(location =>
          this.settings.containByNormalizedCity.includes(
            location.address.normalized_city
          )
        );
      }
      return normalizedCities;
    },
    selectedCategoryGroup: {
      get() {
        return this.$store.state.selectedCategoryGroup;
      },
      set(value) {
        this.$store.commit("setSelectedCategoryGroup", value);
      }
    },
    cityFilterTypes() {
      return this.settings?.cityFilterTypes ?? [];
    },
    categories() {
      // only active categories
      if (this.countByCategory) {
        return this.$store.state.categories.filter(
          item => this.countByCategory[item._id]
        );
      }
      return [];
    },
    featureGroups() {
      const featureGroups = [];

      this.$store.state.featureGroups.forEach(featureGroup => {
        const features = featureGroup.features.filter(
          feature =>
            !feature.internal_control_feature &&
            !!this.countByFeature[feature._id]
        );

        if (features && features.length) {
          featureGroups.push({
            title: featureGroup.title,
            features: features
          });
        }
      });

      return featureGroups;
    },
    categoryGroups() {
      const categoryGroups = [];
      this.$store.state.categoryGroups.forEach(categoryGroup => {
        const categories = categoryGroup.categories.filter(
          category =>
            !category.internal_control_feature &&
            !!this.countByCategory[category._id]
        );

        if (categories && categories.length) {
          categoryGroups.push({
            title: categoryGroup.title,
            categories: categories,
            _id: categoryGroup._id
          });
        }
      });

      return categoryGroups;
    },
    searchString() {
      return this.$store.state.s;
    },
    showDistinctEventsCheckbox() {
      return this.settings.showDistinctEventsCheckbox;
    },
    distinctEvents: {
      get() {
        return this.$store.state.distinctEvents;
      },
      set(value) {
        this.$store.commit("setDistinctEvents", value);
      }
    }
  },
  async created() {
    // load categories and featureGroups to Store
    await this.$store.dispatch("loadCategories");
    await this.$store.dispatch("loadFeatureGroups");
    await this.$store.dispatch("loadCategoryGroups");
    this.s = this.$store.state.s;
  },
  methods: {
    updateSearchString(searchString) {
      this.$store.commit(
        "setSearch",
        searchString !== null ? searchString : ""
      );
    },
    clickedOnFind() {
      this.updateSearchString();
    },
    setCategory(checkboxValue, categoryId) {
      if (checkboxValue && !this.selectedCategories.includes(categoryId)) {
        this.selectedCategories.push(categoryId);
      } else if (
        !checkboxValue &&
        this.selectedCategories.includes(categoryId)
      ) {
        const index = this.selectedCategories.indexOf(categoryId);
        this.selectedCategories.splice(index, 1);
      }
    },
    featureChanged(id) {
      const selectedFeatures = this.$store.state.selectedFeatures;
      const pos = selectedFeatures.indexOf(id);

      // add entry to list
      if (pos === -1) {
        selectedFeatures.push(id);
      } else {
        selectedFeatures.splice(pos, 1);
      }
      this.$store.commit("updateSelectedFeatures", selectedFeatures);
    },
    submit() {
      // just close dialog
      this.$emit("close");
    },
    reset() {
      this.s = "";
      this.$store.commit("setSearch", "");
      this.$store.commit("selectCategories", []);
      this.$store.commit("updateSelectedFeatures", []);
      this.$store.commit("setStartEnd", {
        start: undefined,
        end: undefined
      });
      this.$store.commit("setSelectedCity", "");
      this.$store.commit("setSelectedNormalizedCity", "");
      this.$store.commit("setSelectedCategoryGroup", "");
      this.$store.commit("setDistinctEvents", false);
    }
  },
  watch: {
    s() {
      // if clicked on delete cross, update search
      if (!this.s) this.updateSearchString("");
    },
    searchString(newValue) {
      // update local model on changes
      if (newValue !== this.s) {
        this.s = newValue;
      }
    },
    selectedCategoryGroup() {
      this.selectedCategories = [];
    }
  }
};
